<template>
    <div>
        <el-page-header @back="goBack" content="订单查询"></el-page-header>
        <el-card class="form-container" shadow="never" style="margin-top: 10px">
            <el-form :inline="true"  size="small" label-width="140px">
                <el-form-item label="用户昵称：" label-width="180px" >
                   <el-input v-model="queryUserData.name"></el-input>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11" >
                    <el-button type="primary" @click="searchUser">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table border :data="userList"  :header-cell-style="{background:'#606266'}"  height="190" >
                <el-table-column label="用户ID" prop="userId" align="center"></el-table-column>
                <el-table-column label="用户昵称" prop="name" align="center"></el-table-column>
                <el-table-column label="创建时间"  align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createDt | dateTimeFormat}}
                    </template>
                </el-table-column>
                <el-table-column label="性别" prop="gender" align="center"></el-table-column>
                <el-table-column label="品种" prop="variety" align="center"></el-table-column>
                <el-table-column label="颜色" prop="color" align="center"></el-table-column>
            </el-table>
        </el-card>
        <el-card class="form-container" shadow="never" style="margin-top: 5px">
            <el-form :inline="true"  size="small" label-width="140px">
                <el-form-item label="用户Id：" label-width="180px" >
                    <el-input  v-model="queryOrderData.userId"></el-input>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11" >
                    <el-button type="primary" @click="searchOrder">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table border :data="orderList">
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column label="交易时间"  align="center">
                        <template slot-scope="scope">
                            {{ scope.row.createDt | dateTimeFormat}}
                        </template>
                    </el-table-column>
                    <el-table-column label="订单ID" prop="id"  align="center"></el-table-column>
                    <el-table-column label="用户ID" prop="userId" align="center"></el-table-column>
                    <el-table-column label="商品名称"  align="center">
                        <template slot-scope="scope">
                            <span>{{transformat(scope.row.itemId) === undefined ? "商品不存在":transformat(scope.row.itemId).name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型" align="center" >
                        <template slot-scope="scope">
                            {{scope.row.itemId | iosFilter(iosShopClassifyObj)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="购买数量" prop="count" align="center" ></el-table-column>
                    <el-table-column label="应付金额" align="center">
                        <template slot-scope="scope">
                            <span>{{transformat(scope.row.itemId) === undefined ? "商品不存在":transformat(scope.row.itemId).currentPrice}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="实付金额" align="center" >
                        <template slot-scope="scope">
                            <span>{{transformat(scope.row.itemId) === undefined ? "商品不存在":transformat(scope.row.itemId).originalPrice}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="交易类型" align="center" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.adFlag === true">看广告获取</span>
                            <span v-if="scope.row.adFlag === false">金币支付</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin-top: 5px"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
        </el-card>
    </div>

</template>

<script>
    import {
        searchUser,
        searchOrder

    } from "@/http/cgApi";
    import settingMix from '@/utils/mix/common-setting'
    export default {
        name: "CgOrderData",
        mixins: [settingMix],
        data(){
            return{
                page: {
                    size: 30,
                    page: 1,
                    totalElements: null
                },
                cgShopClassifyObj:{},
                itemList:[],
                orderList:[],
                userList:[],
                queryUserData:{
                    "name":""
                },
                queryOrderData:{
                    "userId":null,
                    "page":1,
                    "size":30
                }
            }
        },
        methods:{
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryOrderData.page = page;
                searchOrder()
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryOrderData.size = size;
                searchOrder()
            },
            searchUser(){
                searchUser(this.queryUserData).then(resp => {
                    this.userList = resp.data.info
                })
            },
            searchOrder(){
                this.queryOrderData.size = this.page.size;
                this.queryOrderData.page = this.page.page;
                console.log(this.queryOrderData)
                if(this.queryOrderData.userId!==null){
                    this.queryOrderData.userId=+this.queryOrderData.userId;
                }
                searchOrder(this.queryOrderData).then(resp => {
                    this.orderList = resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements;
                })
            },
            goBack() {
                this.$router.push({ path: '/cgShopManage'});
            },
            transformat:function(itemId){
                const arr = this.itemList;
                var child = arr.filter(it => it.itemId === itemId);
                return child[0];
            },
        },
        created() {
            this.searchOrder();
        },
    }
</script>

<style scoped>

</style>
